const ResumeApi = [
  {
    id: 1,
    category: 'education',
    year: 'Islamic University Of Indonesia (2017 - 2021)',
    title: 'Bachelor of Informatics',
    desc: 'Studying the fields of IT programming, coding, startup business, information systems and others',
    rate: 'IPK 3.56',
  },
  {
    id: 2,
    category: 'education',
    year: 'Universitas Gadjah Mada (2023 - ongoing)',
    title: 'Master of Computer Science',
    desc: 'Studying the fields of IT programming, coding, startup business, information systems and others',
    rate: '-',
  },
  // {
  //   id: 2,
  //   category: 'education',
  //   year: 'College of Studies (2000 - 2002) ',
  //   title: 'Examples Of Personal Portfolio',
  //   desc: 'Maecenas finibus nec sem ut imperdiet. Ut tincidunt est ac dolor aliquam sodales. Phasellus sed mauris hendrerit, laoreet sem in, lobortis mauris hendrerit ante.',
  //   rate: '4.50/5',
  // },
  // {
  //   id: 3,
  //   category: 'education',
  //   year: 'University of Studies (1997 - 2001) ',
  //   title: 'Tips For Personal Portfolio',
  //   desc: 'If you are going to use a passage. Ut tincidunt est ac dolor aliquam sodales. Phasellus sed mauris hendrerit, laoreet sem in, lobortis mauris hendrerit ante.',
  //   rate: '4.80/5 ',
  // },
  {
    id: 4,
    category: 'experience',
    year: 'Frontend Mobile Native (Jun 2020 - Feb 2021) ',
    title: 'Freelence Android Developer',
    desc: 'Development technology using Native Mobile App with Java',
    rate: '4.70/5 ',
  },
  {
    id: 5,
    category: 'experience',
    year: 'Own Startup (Aug 2019 - Sep 2021) ',
    title: 'Full Stack Developer Ubaform Startup',
    desc: 'Development technology using MERN (MongoDB, ExpressJS, ReactJS, NodeJS). Develop API and Web Admin dashboard and Web Client',
    rate: '4.95/5 ',
  },
  {
    id: 6,
    category: 'experience',
    year: 'Team Lead / Fullstack Developer (Sept 2021 - Sept 2022) ',
    title: 'Nadihealth Startup Malaysia',
    desc: 'Contract | development technology using MERN (MongoDB, ExpressJS, ReactJS, NodeJS). Develop API and Web Admin dashboard',
    rate: '5.00/5 ',
  },
  {
    id: 7,
    category: 'experience',
    year: 'Frontend Developer (Nov 2022 - April 2023) ',
    title: 'Amoda Startup Indonesia',
    desc: 'Contract | development technology using React JS with tailwind and API integrating using GraphQL. Amoda is Web service to show and rent property',
    rate: '4.00/5 ',
  },
  {
    id: 8,
    category: 'experience',
    year: 'Fullstack Engineer (Nov 2022 - ongoing) ',
    title: 'Skilledin Startup Singapore',
    desc: 'Contract | development technology using ReactJS, Golang, MongoDB, TailwindCSS, Ant Design, Azure Devops. Create Admin Dashboard management and Customer Service',
    rate: '4.80/5 ',
  },
]

export default ResumeApi
